import components from '../../common/_components';
import { throttle } from '../../vendors/_throttle-debounce';
import { _getData } from '../../common/_core';
import { _on, _off } from '../../common/_events';

import './offers-highlight-fixed.scss';

const blockName = 'offers-highlight-fixed';

components.add(`js-${blockName}`, (el) => {
    const offerEl = document.querySelector(`[data-offer-id="${_getData(el, 'highlightOfferId')}"]`);
    const scrollHandler = throttle(250, () => {
        const offerElRect = offerEl.getBoundingClientRect();
        const showFixedHighlight = (offerElRect.top > window.innerHeight) || (offerElRect.bottom < 0);

        el.style.display = showFixedHighlight ? 'block' : 'none';
    });

    if (offerEl) {
        _on(el, 'click', `.js-${blockName}__close`, (e) => {
            el.style.display = 'none';
            _off(window, 'scroll', scrollHandler);

            e.preventDefault();
            e.stopPropagation();
        });

        scrollHandler();
        _on(window, 'scroll', scrollHandler);
    }
});
